import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import AddEditAdminDisclaimer from '../compoenets/AddEditAdminDisclaimer';
import appUrl from "../../../../constants/appUrl";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { confirmDialog } from 'primereact/confirmdialog';
const AdminDisclaimer = () => {

    const [rowselect, setRowselect] = useState(null)
    const [dialog, setDialog] = useState();
    const [editable, setEditable] = useState();
    const [disclaimerList, setDisclaimerList] = useState();
    const [res, setRes] = useState(null)

    const GetAllDisclaimer = async () => {
        try {
            const response = await fetch(`${appUrl.baseUrl}api/Disclaimer/GetAllDisclaimers`)
            const data = await response.json();
            setDisclaimerList(data)
        }
        catch (error) {

        }
    }

    const actionTemplate = (rowData) => {
        return (
            <div>
                <Button icon="pi pi-pencil" className="custom-btn-edit" onClick={() => editAction(rowData)} />
                <Button icon="pi pi-trash" className="custom-btn-delete" onClick={() => { confirm(rowData) }} />
            </div>
        );
    }

    const accept = async (rowData) => {
        console.log('rowData', rowData)
        const response = await axios.delete(`${appUrl.baseUrl}api/Disclaimer/DeleteDisclaimerByID/${rowData?.disclaimerID}`)
        setRes(response)
        toast.success("Delete Succesfully")
    }
    const reject = (rowData) => {
        return
    }
    const confirm = (rowData) => {
        confirmDialog({
            header: 'Delete',
            message: 'Are u sure want to delete data',
            accept: () => accept(rowData),
            reject: () => reject(rowData),
            acceptClassName: 'custom-bg',
            rejectClassName: 'custom-white',
        })
    }

    const editAction = (rowData) => {
        setEditable(true);
        setEditable(rowData);
        setDialog(true);
        setRowselect(rowData)
    }


    const onHide = () => {
        setDialog(false)
    }
    useEffect(() => {
        GetAllDisclaimer()
    }, [res])
    return (
        <>
            <ToastContainer />
            <Dialog visible={dialog} onHide={onHide}
                header={editable ? "Edit Disclaimer" : "Add Disclaimer"} style={{ width: "70vw" }}>
                <AddEditAdminDisclaimer editable={editable} dialog={dialog} setRes={setRes} rowData={rowselect} setDialog={setDialog} />
            </Dialog>
            <div className='card'>
                <div className='grid'>
                    <div className="md:col-8"></div>
                    <div className='md:col-2'>
                        <InputText className="w100" placeholder="Search" />
                    </div>

                    <div className="md:col-2" >
                        <div >
                            <Button className="p-button custom-bg w100" label="Add Disclaimer" onClick={() => { setEditable(false); setDialog(true) }} />
                        </div>
                    </div>

                    <div className='md:col-12' >
                        <DataTable
                            value={disclaimerList}
                            scrollable
                            scrollHeight="500px"
                            rows={5}
                            paginator
                        >
                            <Column
                                body={(rowData, index) => {
                                    return index.rowIndex + 1;
                                }}
                                header="Sr. No."
                            />
                            <Column header="Disclaimer" field='disclaimerDescription' />
                            <Column header="Action" body={actionTemplate} />
                        </DataTable>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdminDisclaimer